import { graphql, useStaticQuery } from 'gatsby';
import { injectIntl } from 'gatsby-plugin-intl';
import React, { useEffect } from 'react';
import Footer from './Footer';
import Header from './Header';

const Layout = ({ isHomePage, children, intl }) => {
  const {
    wp: {
      generalSettings: { title },
    },
  } = useStaticQuery(graphql`
    query LayoutQuery {
      wp {
        generalSettings {
          title
          description
        }
      }
    }
  `);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const { hash } = window.location;
      if (hash && document.querySelector(hash)) {
        const element = document.querySelector(hash);
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollTo(0, 0);
      }
    }, 1);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className='' data-is-root-path={isHomePage}>
      <div className='canvas'>
        <Header isHomePage={isHomePage} />
        <main>{children}</main>
        <Footer />        
      </div>
    </div>
  );
};

export default injectIntl(Layout);
